import palette from '@lib/core/src/theme/palette';
import { Stack, styled, Typography } from '@mui/material';

export const Container = styled(Stack)({
  width: '483px',
  padding: '0px 40px 32px 40px',
  gap: '40px'
});

export const TitlesContainer = styled(Stack)({
  gap: '9px',
  width: '100%'
});

export const TitleDescription = styled(Typography)({
  color: palette.typography.grey,
  fontSize: '16px',
  fontWeight: 500
});

export const Title = styled(Typography)({
  color: palette.typography.black,
  fontSize: '28px',
  fontWeight: 600
});

export const UserInfoContainer = styled(Stack)({
  gap: '24px',
  flexDirection: 'row'
});

export const UserInfoCategoryContainer = styled(Stack)({
  gap: '6px'
});

export const UserInfoCategoryTitle = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  color: palette.typography.black
});

export const UserInfoCategoryValue = styled(Typography)({
  color: palette.typography.grey,
  fontSize: '13px',
  fontWeight: 600
});

export const UserInfoImg = styled('img')({
  width: '68px',
  height: '68px',
  borderRadius: '50%',
  objectFit: 'cover',
  padding: '10px',
  backgroundColor: palette.common.white
});

export const InputsContainer = styled(Stack)({
  minHeight: '132px',
  gap: '16px',
  width: '100%'
});

export const InputAndTitleContainer = styled(Stack)({
  gap: '6px'
});

export const InputTitle = styled(Typography)({
  color: palette.typography.grey,
  fontSize: '11px',
  fontWeight: 500
});

export const InputContainer = styled(Stack)({
  alignItems: 'center',
  flexWrap: 'nowrap',
  gap: '8px',
  position: 'relative',
  padding: '12px 10px',
  background: 'white',
  overflow: 'hidden',
  borderRadius: '8px',
  border: `1px solid ${palette.border.grey}`
});

export const InputError = styled(Typography)({
  color: 'red',
  marginTop: '2px',
  fontSize: '12px',
  marginLeft: '10px'
});
